module.exports = __webpack_public_path__ + "static/media/Signup_Flow3.2727f193.png";